import { LIST_TOWNS } from '../actions/townsActions';

export type TownsReducerActionType = {
  type: string;
  payload: Array<{ id: string; name: string }>;
};

const defaultState: Array<{ id: string; name: string }> = [];

const townsReducer = (state = defaultState, action: TownsReducerActionType) => {
  switch (action.type) {
    case LIST_TOWNS:
      return action.payload;
    default:
      return state;
  }
};

export default townsReducer;
